import { PostgrestClient } from '@supabase/postgrest-js';
import { environment } from 'src/environments/environment';
import type { BlumenauDatabase, GenericDatabase } from '.';

export type Databases = {
  blumenau: BlumenauDatabase.Database;
  vm2: GenericDatabase.Database;
};

// id: 'vm2' -> Geo360 database (vm2)
// id: ':cityName' -> City database (:cityName)

export const BASE_POSTGREST_URL = (id: string) => {
  if (id === 'vm2' && (environment as any).apiUrlGenericPostgrest) {
    return (environment as any).apiUrlGenericPostgrest as string;
  }

  const postgrestUrl = environment.postgRestUrl.replace('<placeholder>', id);
  return postgrestUrl;
};

export const postgrestClients = new Map();

type PostgrestClientOptions = {
  stripClientInfo?: boolean;
};

const getAuthHeaders = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const headers: Record<string, string> = {};

  try {
    const publicTokensRaw = window.localStorage.getItem('publicTokens');
    if (publicTokensRaw) {
      try {
        const publicTokens = JSON.parse(publicTokensRaw) as {
          authToken?: string;
          tnToken?: string;
        };

        if (publicTokens?.authToken) {
          headers['X-AUTH-TOKEN'] = publicTokens.authToken;
        }

        if (publicTokens?.tnToken) {
          headers['X-TN-TOKEN'] = publicTokens.tnToken;
        }
      } catch (error) {
        console.error(
          '[postgrest] Erro ao fazer JSON.parse em publicTokens',
          publicTokensRaw,
          error
        );
      }
    }
  } catch {}

  if (!headers['X-AUTH-TOKEN'] || !headers['X-TN-TOKEN']) {
    try {
      const currentUserRaw = window.localStorage.getItem('currentUser');
      if (currentUserRaw) {
        try {
          const currentUser = JSON.parse(currentUserRaw) as {
            authToken?: string;
            tnToken?: string;
          };

          if (currentUser?.authToken && !headers['X-AUTH-TOKEN']) {
            headers['X-AUTH-TOKEN'] = currentUser.authToken;
          }

          if (currentUser?.tnToken && !headers['X-TN-TOKEN']) {
            headers['X-TN-TOKEN'] = currentUser.tnToken;
          }
        } catch (error) {
          console.error(
            '[postgrest] Erro ao fazer JSON.parse em currentUser',
            currentUserRaw,
            error
          );
        }
      }
    } catch {}
  }

  return headers;
};

export const postgrestClient = <T>(
  id = 'plataforma',
  options: PostgrestClientOptions = {}
): PostgrestClient<T> => {
  const url = BASE_POSTGREST_URL(id);
  const shouldStrip = options.stripClientInfo || url.includes('openrest');

  const fetcher = shouldStrip
    ? async (input: RequestInfo, init?: RequestInit) => {
        const request = new Request(input, init);
        const sanitizedHeaders = new Headers(request.headers);
        sanitizedHeaders.delete('x-client-info');
        const sanitizedRequest = new Request(request, {
          headers: sanitizedHeaders,
        });
        return fetch(sanitizedRequest);
      }
    : undefined;

  const postgrestClient = new PostgrestClient<T>(url, {
    headers: getAuthHeaders(),
    fetch: fetcher,
  });

  return postgrestClient;
};
